import { AcbOsSectionProps } from "../../interfaces/Accumulator/types"
import { fetchOsData as fetchBmsOsData, updateOsData as updateBmsOsData } from "../../components/Rest/RestAcbOs"
import { fetchOsData as fetchRemoteOsData, updateOsData as updateRemoteOsData } from "../../components/Rest/RestAcbOsRemoteController"
import { BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import { AcbOsDetails } from "./AcbOsDetails"
import { AcbWifiSettingsUpdate } from "./AcbWifiSettingsUpdate"
import { FirmwareUpdateForm } from "./FirmwareUpdateForm"
import { ChipIcon, WifiIcon } from "./icons"
import { SectionHeading } from "./SectionHeading"

const AcbOsSection = ({ data }: AcbOsSectionProps) => {
    if (!data) {
        return <>Загрузка...</>
    }

    return (
        <BoxWrapper p="p0">
            <FlexWrapper flexDirection="row" justifyContent="space-between" alignItems="stretch">
                <AcbOsDetails data={data} />
                <BoxWrapper bg="bg-primary" r="r10" p="p4" className="relative flex-grow" style={{ minWidth: "400px" }}>
                    <SectionHeading icon={<WifiIcon />} title="WI-FI Настройки" />
                    <AcbWifiSettingsUpdate />
                </BoxWrapper>
            </FlexWrapper>
            <br />
            <BoxWrapper p="p4" bg="bg-primary" r="r15">
                <SectionHeading icon={<ChipIcon />} title="Управление прошивками" />
                <br />
                <FlexWrapper flexDirection="row" justifyContent="space-between" alignItems="stretch">
                    <FirmwareUpdateForm
                        title="FW BMS"
                        versionLabel="Версия FW BMS"
                        version={data.bms_fw_version}
                        fileInputId="fw_bms_file_form"
                        maxFileSize={1000 * 1024}
                        fetchOsData={fetchBmsOsData}
                        updateOsData={updateBmsOsData}
                    />
                    <FirmwareUpdateForm
                        title="FW внешнего пульта"
                        versionLabel="Версия FW BMS внешнего пульта"
                        version={data.accumulator_external_remote_control_fw_version}
                        fileInputId="fw_bms_remote_file_input"
                        maxFileSize={4000 * 1024}
                        fetchOsData={fetchRemoteOsData}
                        updateOsData={updateRemoteOsData}
                    />
                </FlexWrapper>
            </BoxWrapper>
        </BoxWrapper>
    )
}

export default AcbOsSection
